// extracted by mini-css-extract-plugin
module.exports = {"formatted-date":"styles_formatted-date_3OvnYIqu2wkz0VG16gOwVw","formattedDate":"styles_formatted-date_3OvnYIqu2wkz0VG16gOwVw"};